import Swiper from "swiper/bundle";

  document.addEventListener("DOMContentLoaded", function () {
    function sliderWithContent(){
      // content swiper slider 
      const quoteSwiper = new Swiper(".quote-slider", {
        direction: "horizontal",
        effect: "slide",
        loop: false,
        allowTouchMove: false,
      });
      // thumb image swiper slider 
      const galleryThumbs = new Swiper(".gallery-thumbs", {
        spaceBetween: 10,
        slidesPerView: 3,
        freeMode: true,
        watchSlidesProgress: true,
      });

      // large image swiper slider 
      const imageSwiper = new Swiper(".image-slider", {
        mousewheel: false,
        speed: 1000,
        loop: false,
        effect: "fade",
        controller: {
          control: quoteSwiper,
        },
        thumbs: {
          swiper: galleryThumbs,
        },
        pagination: {
          el: ".swiper-pagination",
          type: "fraction",
        },
      });

    }
    sliderWithContent();
});
